define('lib/backbone/Backbone.PodioCollection',['require','underscore','backbone','backbone-super','lib/backbone/Backbone.Mixins.Transport','lib/backbone/Backbone.PodioEvents','lib/backbone/Backbone.PodioModel'],function(require) {

  var _ = require('underscore');
  var Backbone = require('backbone');
  require('backbone-super');

  var MixinTransport = require('lib/backbone/Backbone.Mixins.Transport');
  var PodioEvents = require('lib/backbone/Backbone.PodioEvents');

  var podioCollection = Backbone.Collection.extend({

    constructor: function(models, options){
      this.configure(options || {});

      Backbone.Collection.prototype.constructor.apply(this, _.toArray(arguments));

      if (this._afterInitialize) {
        this._afterInitialize(options);
      }
    },

    configure: function(options) {
      if (!this.model) {
        this.model = require('lib/backbone/Backbone.PodioModel');
      }
    },

    parse: function (response, xhr) {
      if (this.useDirectAPIAccess) {
        return response;
      } else {
        if (response.status === 'ok' && response.data.object) {
          return response.data.object;
        } else if ((_.isUndefined(response.data) || _.isUndefined(response.data.object)) && response.status !== 'error') {
          return response;
        }
      }

    },

    url: function() {
      var url;

      if (this.useDirectAPIAccess) {
        url = this._getAPIHostName() + _.result(this, 'urlAPI');
      } else {
        url = _.result(this, 'urlRails');
      }

      return url;
    },

    fetch: function(options) {
      if (!options || !options['silentLoading']) {
        this.trigger('loading');
      }

      this.fetchAttempted = true;

      return this._super(options);
    },

    save: function(options) {
      var self = this;

      return this.sync('update', this, options || {}).done(function(responseData) {
        self.set(self.parse(responseData, options), options);
        self.resetTrackingOnModels();
        self.removedModels = false;
      });
    },

    remove: function() {
      this.removedModels = true;

      this._super.apply(this, arguments);
    },

    resetTrackingOnModels: function() {
      this.each(function(model) {
        if (_.isFunction(model.restartTracking)) {
          model.restartTracking();
        }
      });
    },

    getByIds: function(ids) {
      return this.filter(function(item) {
        return _.include(ids, item.id);
      });
    },

    getByAttribute: function(attribute, value) {
      var matchedItem = null;
      _.each(this.models, function(item) {
        if (item.get(attribute) === value) {
          matchedItem = item;
        }
      });
      return matchedItem;
    },

    hasUnsavedModels: function() {
      return this.any(function(m) {
        return !_.isEmpty(m.unsavedAttributes());
      });
    },

    hasUnsavedOrNewModels: function() {
      if (this.removedModels) {
        return true;
      } else {
        return this.any(function(m) {
          return m.isNew() || !_.isEmpty(m.unsavedAttributes());
        });
      }
    },

    hasInvalidModels: function(indicateErrors) {
      var valid = true;
      var validationPassed;

      // using .each instead of .any since we need to trigger validation on all entities
      this.each(function(m) {
        validationPassed = m.isValid(indicateErrors);
        valid = valid && validationPassed;
      });

      return !valid;
    }

  });

  // Mixin Podio Events and common transport layer
  _.extend(podioCollection.prototype, PodioEvents, MixinTransport);

  return podioCollection;

});

